<template>
  <div>
    <v-stepper-content :step="step">
      <div class="person-form">
        <v-form ref="fluForm">
          <v-alert :value="covidMessage" type="error">{{
            covidQuestions.message
          }}</v-alert>
          <v-col cols="12" md="12">
            <p class="h1">
              <b>{{ covidQuestions.disclaimer }}</b>
            </p>
            <p v-for="covid in covidQuestions.questions" :key="covid.id">
              {{ covid.question }}
              <v-radio-group
                :mandatory="false"
                v-model="customField[covid.id]"
                :rules="[rules.required]"
                row
              >
                <v-radio
                  v-for="option in covid.options"
                  :key="option.id"
                  :label="option.option"
                  :value="option.option"
                ></v-radio>
              </v-radio-group>
            </p>
          </v-col>
        </v-form>
        <v-col cols="12" md="12">
          <v-row>
            <v-col style="text-align: right">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="float-right hp--btn"
                @click="submitCovidQuestions"
                >Continue</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </div>
    </v-stepper-content>
  </div>
</template>

<script>
export default {
  props: {
    step: Number,
    covidQuestions: Object
  },
  data() {
    return {
      rules: {
        required: v => !!v || "This field is required."
      },
      customField: {},
      covidMessage: false
    };
  },
  methods: {
    submitCovidQuestions() {
      const that = this;
      if (this.$refs.fluForm.validate()) {
        let valid = true;
        this.covidQuestions.questions.forEach(function(covid) {
          if (covid.success !== that.customField[covid.id]) {
            valid = false;
          }
        });
        if (valid) {
          this.covidMessage = false;
          this.$emit("toParent", this.customField, this.step + 1);
          // this.step = this.steps.fluQuestions.step + 1;
        } else {
          this.covidMessage = true;
        }
      }
    }
  }
};
</script>
